export class Accordion {

	constructor(selector, options = {}) {

		this.parent = typeof selector === 'string'
			? document.querySelector(selector)
			: selector;

		if (!this.parent) return;

		const defaultOptions = {
			triggerClass: '.jsAccordionTrigger',
			targetClass: '.jsAccordionTarget',
		}

		this.options = Object.assign(defaultOptions, options);

		this.trigger = null;
		this.target = null;

		this._onClick = this._onClick.bind(this);
		this.isAnimating = false; // Lock flag to prevent multiple animations

		this._setup();
	}

	_setup() {

		const trigger = this.parent.querySelector(this.options.triggerClass);
		const target = this.parent.querySelector(this.options.targetClass);

		this.trigger = trigger;
		this.target = target;

		trigger.addEventListener("click", this._onClick);

	}

	_onClick(event) {
		const trigger = event.currentTarget;
		// If an animation is already running, ignore new clicks
		if (this.isAnimating) return;

		trigger.classList.toggle('active');
		this._toggleHeight(this.target);
	}

	_toggleHeight(el) {

		const isActive = el.classList.contains('active');
		this.isAnimating = true; // Start animation lock

		if (!isActive) {
			// Opening
			Object.assign(el.style, {
				height: '0px',
				overflow: 'hidden',
				opacity: '0',
			});

			// Force reflow
			el.offsetHeight;

			el.classList.add('active');
			Object.assign(el.style, {
				height: el.scrollHeight + 'px',
				opacity: '1',
			});

		} else {
			// Closing
			Object.assign(el.style, {
				height: el.scrollHeight + 'px',
				overflow: 'hidden',
				opacity: '1',
			});

			// Force reflow
			el.offsetHeight;

			Object.assign(el.style, {
				height: '0px',
				opacity: '0',
			});
		}

		const cleanup = () => {
			if (!isActive) el.style.height = '';
			if (isActive) el.classList.remove('active');

			Object.assign(el.style, {
				height: '',
				overflow: '',
				opacity: '',
			});

			el.removeEventListener('transitionend', cleanup);

			// Unlock animation
			this.isAnimating = false;
		};

		el.addEventListener('transitionend', cleanup);
	}

	reset() {	

		if(this.trigger && this.target ) {

			if( this.trigger.classList.contains('active') && this.target.classList.contains('active') ) {

				this.trigger.classList.remove('active');
				this.target.classList.remove('active');

			}

		}

	}

}
